import axios from "axios"
import GlobalVariable from "./global"
const baseApiUrl = GlobalVariable.BASE_API_URL
const headerText = GlobalVariable.headerText
const DocusignTitle = 'You have received an email from DocuSign with the link to the Annual Declaration for review. Please carefully review the Annual Declaration and sign it via DocuSign. Refresh this page once the signature has been completed.'
const DocusignTitleDL = 'You have received an email from DocuSign with the link to the Declaration Letter for review. Please carefully review the Declaration Letter and sign it via DocuSign. Refresh this page once the signature has been completed.'
const InvoicePaymentModes = [{ value: 1, label: 'WireTransfer' }, { value: 2, label: 'CreditCard' }, { value: 3, label: 'PayLater' }, { value: 4, label: 'GPay' }, { value: 5, label: 'ApplePay' }]
const InvoicePaymentStatus = [{ value: 1, label: 'Pending' }, { value: 2, label: 'Processed' }, { value: 3, label: 'Failed' }]
const WOStatus = [{ value: 1, label: 'Active' }, { value: 2, label: 'Deleted' }, { value: 3, label: 'Cancelled' }]
const errorresponse = "Something Went Wrong. Please approach technical team."
const datesList = ["st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "st"]
const monthnames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
const fullmonthnames = [
  { key: '01', value: 'Jan' },
  { key: '02', value: 'Feb' },
  { key: '03', value: 'Mar' },
  { key: '04', value: 'Apr' },
  { key: '05', value: 'May' },
  { key: '06', value: 'Jun' },
  { key: '07', value: 'Jul' },
  { key: '08', value: 'Aug' },
  { key: '09', value: 'Sep' },
  { key: '10', value: 'Oct' },
  { key: '11', value: 'Nov' },
  { key: '12', value: 'Dec' }
]

const addResponseInterceptor = async (axiosInstance) => {
  axiosInstance.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    const originalRequest = error.config
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      const access_token = error.response.headers['x-auth-token']
      const refresh_token = error.response.headers['x-refresh-token']
      localStorage.setItem("token", access_token)
      localStorage.setItem("refresh_token", refresh_token)
      originalRequest.headers['Authorization'] = `Bearer ${access_token}`
      return axiosInstance(originalRequest)
    }
    return Promise.reject(error)
  })
}
export const DefaultConfig = () => {
  let authAxios
  let authAxiosMulti
  if (localStorage.getItem("userData")) {
    const localStorageToken = localStorage.getItem('token')
    const refreshToken = localStorage.getItem('refresh_token')
    authAxios = axios.create({
      baseURL: baseApiUrl,
      headers: { Authorization: `Bearer ${localStorageToken}`, "x-refresh-token": refreshToken },
      withCredentials: true
    })
    addResponseInterceptor(authAxios)
    authAxiosMulti = axios.create({
      baseURL: baseApiUrl,
      headers: {
        Authorization: `Bearer ${localStorageToken}`,
        "Content-Type": "multipart/form-data",
        "x-refresh-token": refreshToken
      },
      withCredentials: true

    })
    addResponseInterceptor(authAxiosMulti)
  }

  const sorter = (sortname, sortorder, filteredData) => {
    const sortData = filteredData
    sortData.sort((a, b) => {
      if (typeof a[sortname] === "number" && typeof b[sortname] === "number") {
        if (sortorder === "asc") {
          return parseInt(b[sortname]) > parseInt(a[sortname]) ? 1 : parseInt(b[sortname]) < parseInt(a[sortname]) ? -1 : 0
        } else {
          return parseInt(a[sortname]) > parseInt(b[sortname]) ? 1 : parseInt(a[sortname]) < parseInt(b[sortname]) ? -1 : 0
        }
      } else if (
        typeof a[sortname] === "string" && typeof b[sortname] === "string") {
        if (sortorder === "asc") {
          return a[sortname].toLowerCase() > b[sortname].toLowerCase() ? 1 : a[sortname].toLowerCase() < b[sortname].toLowerCase() ? -1 : 0
        } else {
          return b[sortname].toLowerCase() > a[sortname].toLowerCase() ? 1 : b[sortname].toLowerCase() < a[sortname].toLowerCase() ? -1 : 0
        }
      } else {
        if (sortorder === "asc") {
          return a[sortname] > b[sortname] ? 1 : a[sortname] < b[sortname] ? -1 : 0
        } else {
          return b[sortname] > a[sortname] ? 1 : b[sortname] < a[sortname] ? -1 : 0
        }
      }
    })
    return sortData
  }

  const ReplaceString = (value) => {
    if (value) {
      return new Date(value.replace(/(\d+)(st|nd|rd|th)/, '$1'))
    }
    return ''
  }

  const DateFormat = (value) => {
    if (value) {
      const monthname = monthnames[new Date(value).getMonth()]
      const datevalue = `0${new Date(value).getDate()}`.slice(-2)
      const yearvalue = new Date(value).getFullYear()
      return `${datevalue}-${monthname}-${yearvalue}`
    } else {
      return ""
    }
  }

  const StringtoDateMonthYearFormat = (valueDate) => {
    if (valueDate) {
      const splitString = valueDate.split("-")
      if (splitString.length === 3) {
        const datevalue = splitString[0]
        const findMonth = fullmonthnames.find(find => find.key === splitString[1])
        let monthname = ''
        if (findMonth) {
          monthname = findMonth.value
        }
        const yearvalue = splitString[2]
        return `${datevalue}-${monthname}-${yearvalue}`
      }
    }
    return ""
  }

  const YearMonthDateFormat = (value) => {
    if (value) {
      // const splitDateFormat = value.split("T")
      // const splitDate = splitDateFormat.length > 0 ? splitDateFormat[0] : ''
      // if (splitDate) {
      //   const splitString = splitDate.split("-")
      //   if (splitString.length === 3) {
      //     const yearvalue = splitString[0]
      //     const findMonth = fullmonthnames.find(find => find.key === splitString[1])
      //     let monthname = ''
      //     if (findMonth) {
      //       monthname = findMonth.value
      //     }
      //     const datevalue = splitString[2]
      //     return `${monthname} ${datevalue && datevalue.replace(/^0/, '')}${datesList[datevalue - 1]}, ${yearvalue}`
      //   }
      // }
      const date = new Date(value)

      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      return formattedDate
    }
    return ""
  }

  const DateConversion = (dateStr) => {
    if (dateStr) {
      // Create a Date object from the input string
      const date = new Date(dateStr)

      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      return formattedDate
    }
    return ''
    // if (dateStr) {
    //   // Convert to Date object
    //   const date = new Date(dateStr)

    //   // Custom function to add ordinal suffix
    //   function addOrdinalSuffix(day) {
    //     if (day >= 11 && day <= 13) {
    //       return `${day}th`
    //     }

    //     const lastDigit = day % 10
    //     switch (lastDigit) {
    //       case 1:
    //         return `${day}st`
    //       case 2:
    //         return `${day}nd`
    //       case 3:
    //         return `${day}rd`
    //       default:
    //         return `${day}th`
    //     }
    //   }

    //   // Format date and time
    //   const formattedDate = date.toLocaleDateString("en-US", {
    //     month: "short",
    //     day: "numeric",
    //     year: "numeric"
    //   })

    //   // Extract day from the formatted date
    //   const day = formattedDate.match(/\d+/)[0]

    //   // Add ordinal suffix to the day
    //   const ordinalDay = addOrdinalSuffix(day)

    //   // Combine the formatted date, ordinal day, and formatted time
    //   const formattedDateTime = `${formattedDate.replace(/\d+/, ordinalDay)}`
    //   return formattedDateTime
    // }
    // return ''
  }

  const DateTimeConversion = (dateStr) => {
    if (dateStr) {
      // // Convert to Date object
      // const date = new Date(dateStr)

      // // Custom function to add ordinal suffix
      // function addOrdinalSuffix(day) {
      //   if (day >= 11 && day <= 13) {
      //     return `${day}th`
      //   }

      //   const lastDigit = day % 10
      //   switch (lastDigit) {
      //     case 1:
      //       return `${day}st`
      //     case 2:
      //       return `${day}nd`
      //     case 3:
      //       return `${day}rd`
      //     default:
      //       return `${day}th`
      //   }
      // }

      // // Format date and time
      // const formattedDate = date.toLocaleDateString("en-US", {
      //   month: "short",
      //   day: "numeric",
      //   year: "numeric"
      // })
      // const formattedTime = date.toLocaleTimeString("en-US", {
      //   hour: '2-digit', minute: '2-digit', second: '2-digit'
      // })

      // // Extract day from the formatted date
      // const day = formattedDate.match(/\d+/)[0]

      // // Add ordinal suffix to the day
      // const ordinalDay = addOrdinalSuffix(day)

      // // Combine the formatted date, ordinal day, and formatted time
      // const formattedDateTime = `${formattedDate.replace(/\d+/, ordinalDay)} ${formattedTime}`
      // return formattedDateTime

      // Create a Date object from the input string
      const date = new Date(dateStr)
      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      const formattedTime = date.toLocaleTimeString("en-US", {
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      })
      const formattedDateTime = `${formattedDate} ${formattedTime}`

      return formattedDateTime
    }
    return ''
  }

  const AmountFormat = (dataArray) => {
    let x = dataArray
    x = Number.parseFloat(x).toFixed(2)
    x = x.toString()
    let afterPoint = ""
    if (x.indexOf(".") > 0) {
      afterPoint = x.substring(x.indexOf("."), x.length)
    }
    x = Math.floor(x)
    x = x.toString()
    let lastThree = x.substring(x.length - 3)
    const otherNumbers = x.substring(0, x.length - 3)
    if (otherNumbers !== "") {
      lastThree = `,${lastThree}`
    }
    const res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint
    if (res) {
      return `${res}`
    } else {
      return ``
    }
  }

  const selectStyles = {
    container: (provided) => ({
      ...provided,
      marginTop: 0
    }),
    valueContainer: (provided) => ({
      ...provided,
      overflow: "visible"
    }),
    placeholder: (base, state) => ({
      ...base,
      position: "absolute",
      top: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) ? '-45%' : '20%',
      transition: 'top 0.2s, font-size 0.2s',
      fontSize: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) && 14,
      background: "#fff",
      padding: "0 5px",
      fontWeight: 500,
      color: '#000'
    })
  }

  const getYear = (date) => {
    const year = date.getFullYear()
    return `${year}`
  }

  const myEncodeURIComponent = (value) => {
    return encodeURIComponent(value)
  }

  const emailDurationTime = 30 * 1000
  const zoomInOut = { animate: { opacity: 1, scale: 1 }, transition: { duration: 1, delay: 0.1 }, initial: { opacity: 0, scale: 0.5 }, exit: { opacity: 0, scale: 0.5 } }
  const leftToRight = { animate: { x: 0 }, transition: { type: 'slide', stiffness: 120 }, initial: { x: '-100%' }, exit: { x: '100%' } }
  return {
    headerText,
    selectStyles,
    DocusignTitle,
    DocusignTitleDL,
    InvoicePaymentModes,
    InvoicePaymentStatus,
    WOStatus,
    errorresponse,
    authAxios,
    authAxiosMulti,
    sorter,
    datesList,
    monthnames,
    DateFormat,
    YearMonthDateFormat,
    AmountFormat,
    StringtoDateMonthYearFormat,
    DateTimeConversion,
    DateConversion,
    ReplaceString,
    emailDurationTime,
    zoomInOut,
    leftToRight,
    myEncodeURIComponent,
    getYear
  }
}
